export const isS1F2Device = (): boolean => {
  if (typeof window === 'undefined' || !('localStorage' in window)) {
    return false;
  }

  try {
    const os = window.localStorage.getItem('device_os');
    const type = window.localStorage.getItem('device_type');
    const deviceId = window.localStorage.getItem('device_id');
    return os === 'android' && type === 'adyen' && (deviceId?.startsWith('S1F2') ?? false);
  } catch {
    return false;
  }
};
